var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDelete = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33317 4.1665L3.8712 13.313C3.97514 15.08 4.02711 15.9635 4.40423 16.634C4.73622 17.2242 5.2401 17.6993 5.8488 17.9961C6.54027 18.3332 7.42529 18.3332 9.19533 18.3332H10.8043C12.5744 18.3332 13.4594 18.3332 14.1509 17.9961C14.7596 17.6993 15.2635 17.2242 15.5954 16.634C15.9726 15.9635 16.0245 15.08 16.1285 13.313L16.6665 4.1665M3.33317 4.1665H1.6665M3.33317 4.1665H16.6665M16.6665 4.1665H18.3332M8.33317 8.33317V14.1665M11.6665 8.33317V11.6665M13.3332 4.1665L12.9557 3.03405C12.7918 2.54229 12.7098 2.2964 12.5578 2.11462C12.4235 1.95409 12.2511 1.82983 12.0564 1.75324C11.8359 1.6665 11.5767 1.6665 11.0583 1.6665H8.94136C8.42299 1.6665 8.16381 1.6665 7.94328 1.75324C7.74854 1.82983 7.57614 1.95409 7.44189 2.11462C7.28987 2.2964 7.20791 2.54229 7.04399 3.03405L6.6665 4.1665",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDelete);
export default ForwardRef;